import { expiryClockForRightClick } from "@/components/icons/SVGIcons";
import expiryEditStore from "@/store/expiryEditStore";
import featureFlagStore from "@/store/featureFlagStore";
import {
  IAnchorRect,
  canEditTradeExpiry,
} from "../helper/cellRenderers/MainTableActionSummaryESLevel/ExpiresCellRenderer/expiryEditHelpers";

// LQC-2678 - the ES-level "Edit Expiry" right-click item, a second route to the
// popover the Expires column's pencil opens. Same role/status/flag gate as the
// pencil, so the two can never disagree about who may extend a trade.

// Where the popover anchors. AG Grid gives the menu item's action() no event, so
// the right-click point is recorded by the grid's onCellContextMenu just before
// the menu opens. Module scope rather than a store: it is read once, on click,
// and re-rendering anything on a right-click would be waste.
let lastContextMenuPoint: { x: number; y: number } | null = null;

export function recordExpiryAnchorFromEvent(event: unknown): void {
  const mouseEvent = event as MouseEvent | undefined;
  if (typeof mouseEvent?.clientX !== "number") return;
  lastContextMenuPoint = { x: mouseEvent.clientX, y: mouseEvent.clientY };
}

// A zero-size rect at the click point. calculateExpiryPopoverPosition flips the
// popover off a viewport edge from this exactly as it does off the pencil.
export function returnAnchorRectFromPoint(x: number, y: number): IAnchorRect {
  return { top: y, left: x, bottom: y, right: x };
}

// Centre of the viewport, for the case where no right-click point was recorded
// (a keyboard-opened menu, or a grid without the onCellContextMenu wire-up).
function returnFallbackAnchorRect(): IAnchorRect {
  const x = Math.round(window.innerWidth / 2);
  const y = Math.round(window.innerHeight / 2);
  return returnAnchorRectFromPoint(x, y);
}

export function canShowEditExpiryMenuItem(data: any, flagOn: boolean): boolean {
  if (!data?.esid) return false;
  return canEditTradeExpiry(data?.role, flagOn, data?.status);
}

export function returnEditExpiryContextMenuObject(
  params: any,
  cryptoID: string | undefined,
) {
  return {
    name: "Edit Expiry",
    icon: expiryClockForRightClick,
    cssClasses: ["EditExpiryActionButtonER"],
    action: () => {
      const point = lastContextMenuPoint;
      expiryEditStore.getState().openExpiryEdit({
        esid: params.node.data.esid,
        anchorRect: point
          ? returnAnchorRectFromPoint(point.x, point.y)
          : returnFallbackAnchorRect(),
        cryptoID,
      });
    },
  };
}

// Empty unless this trade may have its expiry edited, so the call sites can
// spread it unconditionally.
export function returnEditExpiryContextMenuItems(
  params: any,
  cryptoID: string | undefined,
) {
  const flagOn = featureFlagStore.getState().tradeExpiryEdit;
  if (!canShowEditExpiryMenuItem(params?.node?.data, flagOn)) return [];
  return [returnEditExpiryContextMenuObject(params, cryptoID)];
}
